import { WeatherShareIcon, WeatherDisplayIcon, WeatherRemoveIcon } from '@/resource/IconComponentSets';
import { ISoilQueriesModel } from '@/util/Request/requestType';
import React, { useEffect, useState } from 'react';
import './index.less';
import IF from '@/components/IF';

interface IProps {
    removeButtonClicked?: (queryId: number) => void
    displayButtonClicked?: (queryId: number) => void
    shareButtonClicked?: (queryId: number) => void
    data: ISoilQueriesModel
}

const SoilQueryRecord = (props: IProps) => {
    const {
        removeButtonClicked,
        displayButtonClicked,
        shareButtonClicked,
        data
    } = props;

    const [title, setTitle] = useState('Name');
    const [locationLength, setLocationLength] = useState(0);
    const [locationListStr, setLocationListStr] = useState<string>('');
    const [currentPage, setCurrentPage] = useState('0');

    useEffect(() => {
        if (data) {
            setTitle(data.queryName);
            const options = JSON.parse(data.options);
            setCurrentPage(options.currentPage);
            switch(options.currentPage) {
                case '0': {
                    setLocationLength(options.placeSelectSet?.length);
                    const coordinatesString = options.placeSelectSet?.map((item) => {
                        return `(${item.lng}, ${item.lat})`;
                    });
                    setLocationListStr(coordinatesString?.join(' ; '));
                    break;
                }
                case '1': {
                    setLocationLength(options.coordinatesSet?.length);
                    setLocationListStr(options.coordinatesSet?.join(' ; '));
                    break;
                }
                case '2': {
                    setLocationLength(options.checkedNames?.length);
                    setLocationListStr(options.checkedNames?.join(','));
                    break;
                }
                case '3': {
                    setLocationLength(options.polyPoint?.length);
                    const pointArr = options.polyPoint?.map((point) => {
                        return `(${point.lng},${point.lat})`;
                    });
                    setLocationListStr(pointArr?.join(';'));
                    break;
                }
            }
        }
    }, [data]);

    return (
        <div className='soil-query-record-container'>
            <div className='query-title-div'>
                <p>{title}</p>
                <p>
                    {data.lastDate}
                </p>
            </div>
            <div className='all-location-div'>
                <IF show={currentPage === '0'}>
                    <p>Location({locationLength})</p>
                </IF>
                <IF show={currentPage === '1'}>
                    <p>Coordinate({locationLength})</p>
                </IF>
                <IF show={currentPage === '2'}>
                    <p>Admin Area({locationLength})</p>
                </IF>
                <IF show={currentPage === '3'}>
                    <p>Draw on map({locationLength})</p>
                </IF>
                <p className='location-p'>{locationListStr}</p>
            </div>
            <div className='all-location-div '>
                {/* <p>Properties({data.hierarchies.length})</p>
                {
                    data.hierarchies.map((hierarchy) => (
                        <p key={`${hierarchy.supplier}-${hierarchy.variable}-${hierarchy.frequency}`}>
                            {hierarchy.supplier}/{hierarchy.variable}/{hierarchy.frequency}
                        </p>
                    ))
                } */}
            </div>
            <div className='weather-operation-div'>
                <button onClick={() => removeButtonClicked(data.queryId) }><WeatherRemoveIcon /></button>
                <button onClick={() => displayButtonClicked(data.queryId) }><WeatherDisplayIcon /></button>
                <button onClick={() => shareButtonClicked(data.queryId) }><WeatherShareIcon /></button>
            </div>
        </div>
    );
};

export default SoilQueryRecord;
